import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApiResponse, ContractComplianceDto, ContractGroupKey } from '@klaro7/shared-types';

import api from '@/lib/api';

export const contractQueryKeys = {
  compliance: ['contracts', 'me', 'compliance'] as const,
};

async function fetchCompliance(): Promise<ContractComplianceDto> {
  const response = await api.get<ApiResponse<ContractComplianceDto>>('/contracts/me/compliance');
  return response.data.data;
}

async function acceptContracts(groups: ContractGroupKey[]): Promise<ContractComplianceDto> {
  const response = await api.post<ApiResponse<ContractComplianceDto>>('/contracts/me/accept', { groups });
  return response.data.data;
}

export function useContractCompliance() {
  return useQuery({
    queryKey: contractQueryKeys.compliance,
    queryFn: fetchCompliance,
  });
}

export function useAcceptContracts() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (groups: ContractGroupKey[]) => acceptContracts(groups),
    onSuccess: (data) => {
      queryClient.setQueryData(contractQueryKeys.compliance, data);
    },
  });
}
